import {
  AUTH_COOKIE_NAME,
  COMMUNITY_COOKIE_NAME,
  APP_ENV,
  TTP_ONBOARDING_URL,
  TTP_UA_HOME_URL,
  TTP_UA_HOME,
  UA_DOMAIN_NAME,
} from "../config";
import Cookies from "js-cookie";
import { decodeJWT } from "../lib/jwt";
export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

export function setCookie(name, value, expires, path, domain, secure) {
  document.cookie =
    name +
    " = " +
    encodeURIComponent(value) +
    "  " +
    (!expires ? "" : "; expires = " + expires.toUTCString()) +
    (!path ? "" : "; path = " + path) +
    (!domain ? "" : "; domain = " + domain) +
    (secure === true ? "; secure" : "");
}

export const setCookieMaxAge = (name, value, options = {}) => {
  options = {
    path: "/",
    // add other defaults here if necessary
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
};


// Expiry of the refresh token an auth payload carries, or null when there is none to
// read. Missing or unreadable is treated the same as absent: callers then fall back to
// what they knew, rather than guessing.
const getRefreshTokenExpiry = (authInfos) => {
  try {
    const { exp } = decodeJWT(authInfos?.refreshToken);
    return exp ? new Date(exp * 1000) : null;
  } catch (e) {
    return null;
  }
};

// The auth cookie carries both the access token and the refresh token. Its browser
// expiry used to be built from the access token, so the browser deleted the cookie at
// the exact moment the access token expired and took the refresh token down with it.
// Every gopeople call then threw "No GoPeople auth stored" from the request
// interceptor, before any request was sent, so the session could neither renew itself
// nor sign out cleanly. The cookie has to outlive the access token and expire with the
// refresh token instead.
// It can only ever push that expiry further out: a refresh token that is already
// expired, or one gopeople issued stale, would otherwise set the cookie in the past and
// delete the session outright.
const resolveAuthCookieExpiry = (value, fallback) => {
  let auth = value;
  if (typeof value === "string") {
    try {
      auth = JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  const refreshExpiry = getRefreshTokenExpiry(auth);
  if (
    refreshExpiry &&
    (!(fallback instanceof Date) || refreshExpiry > fallback)
  ) {
    return refreshExpiry;
  }

  return fallback;
};

export const setAuthCookie = (value, dtExpire) => {
  const onProd =
    typeof window !== "undefined" &&
    window.location.hostname.includes(UA_DOMAIN_NAME);

  setCookie(
    AUTH_COOKIE_NAME,
    value,
    resolveAuthCookieExpiry(value, dtExpire),
    "/",
    onProd ? UA_DOMAIN_NAME : undefined
  );

  // Drop the duplicate host-only cookie from earlier writes.
  if (onProd) {
    setCookie(AUTH_COOKIE_NAME, "", new Date(0), "/");
  }
};

export const getAuthInfosFromCookie = () => {
  const cookie = getCookie(AUTH_COOKIE_NAME);

  if (!cookie) {
    return null;
  }

  return JSON.parse(cookie);
};

export const getCommunityFromCookie = () => {
  const cookie = getCookie(COMMUNITY_COOKIE_NAME);

  if (!cookie) {
    return null;
  }

  return JSON.parse(cookie);
};

export const authHasExpired = (authInfos) => {
  const now = Math.floor(new Date().getTime() / 1000);

  // The access token lapsing does not end the session while a usable refresh token
  // remains: getValidGoPeopleToken renews it on the next gopeople call. Reporting the
  // session as expired here is what made the seven callers of this function delete the
  // cookie, and the refresh token inside it, before that renewal could ever run.
  const refreshExpiry = getRefreshTokenExpiry(authInfos);
  if (refreshExpiry && refreshExpiry.getTime() > Date.now()) {
    return false;
  }

  return (
    !authInfos ||
    typeof authInfos !== "object" ||
    !authInfos.createdAt ||
    !authInfos.expiresIn ||
    now >= parseFloat(authInfos.createdAt) + parseFloat(authInfos.expiresIn)
  );
};

export const getLocalStorageUser = () => {
  const stringUser = localStorage.getItem("user");
  let user = [];

  try {
    user = JSON.parse(stringUser);
  } catch (e) {}
  return user instanceof Object ? user : {};
};

export const getLocalStorageAuth = () => {
  const stringAuth = localStorage.getItem("auth");
  let auth = {};

  try {
    auth = JSON.parse(stringAuth);
  } catch (e) {}
  return typeof auth === "object" ? auth : {};
};

export const setLocalStorageAuth = (auth) => {
  if (typeof auth === "object") {
    localStorage.setItem("auth", JSON.stringify(auth));
    return auth;
  }
  if (auth == null) {
    localStorage.removeItem("auth");
  }
};

export const getLocalStorageCookie = () => {
  const stringAuth = localStorage.getItem("cookie_auth");
  let cookie_auth = null;

  try {
    cookie_auth = JSON.parse(stringAuth);
  } catch (e) {}
  return cookie_auth && typeof cookie_auth === "object" ? cookie_auth : null;
};

export const setLocalStorageCookie = (cookie_auth) => {
  if (cookie_auth && typeof cookie_auth === "object") {
    localStorage.setItem("cookie_auth", JSON.stringify(cookie_auth));
    return cookie_auth;
  }
  if (cookie_auth == null) {
    localStorage.removeItem("auth");
  }
};

export const logout1 = (redirect = true) => {
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() - 1000);

  setCookie(`ttp_auth_${APP_ENV}`, "", dtExpire, "/", "unitedassociates.be");
  setCookie(`ttp_auth_${APP_ENV}`, "", dtExpire, "/");

  setCookie(
    `ttp_community_${APP_ENV}`,
    "",
    dtExpire,
    "/",
    "unitedassociates.be"
  );
  const cookieKey = `ttp_auth_${APP_ENV}`;

  Cookies.remove(cookieKey, {
    domain: UA_DOMAIN_NAME,
    path: "/",
  });

  Cookies.remove(`ttp_community_${APP_ENV}`, {
    domain: UA_DOMAIN_NAME,
    path: "/",
  });

  localStorage.removeItem("teamCurrentUrl");

  if (redirect) {
    window.location.assign(`${TTP_UA_HOME}`);
    // window.location.assign(`${TTP_UA_HOME_URL}`);
  }
};

export const logout = (redirect = true) => {
  const cookieKey = `ttp_auth_${APP_ENV}`;
  const communityKey = `ttp_community_${APP_ENV}`;
  const domains = ["unitedassociates.be"];

  domains.forEach((domain) => {
    Cookies.remove(cookieKey, { domain, path: "/" });
    Cookies.remove(communityKey, { domain, path: "/" });
  });

  Cookies.remove(cookieKey, { path: "/" });
  Cookies.remove(communityKey, { path: "/" });
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() - 3600000 * 1000);

  setCookie(`ttp_auth_${APP_ENV}`, "", dtExpire, "/", "unitedassociates.be");
  setCookie(
    `ttp_community_${APP_ENV}`,
    "",
    dtExpire,
    "/",
    "unitedassociates.be"
  );
  localStorage.removeItem("teamCurrentUrl");
  localStorage.removeItem(`ttp_auth_${APP_ENV}`);
  localStorage.removeItem(`ttp_lang_${APP_ENV}`);

  if (redirect) {
    window.location.assign(`${TTP_ONBOARDING_URL}`);
  }
};

export const getUserCurrentNavCommunity = (user, currentNavCommunityId) => {
  if (
    currentNavCommunityId &&
    user.communities &&
    user.communities.length > 0
  ) {
    let currentUserNavCommunity = user.communities.filter(
      (c) => c.id === currentNavCommunityId
    )[0];
    if (currentUserNavCommunity) {
      return currentUserNavCommunity;
    }
  }
  return null;
};

export const createAuthCookie = (data) => {
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() - 3600000 * 1000);
  const expiry = Date.now() + data.token.expires_in;

  setCookieMaxAge(
    `ttp_auth_${APP_ENV}`,
    JSON.stringify({
      token: data.token.access_token,
      id: data.user.id,
      email: data.user.mainEmail,
      expiresIn: data.token.expires_in,
      createdAt: data.token.createdAt,
      expiry: expiry,
      scope: data.token.scope,
      // fullName: encodeURIComponent(
      //   data.user.firstName + " " + data.user.lastName
      // ),
    }),
    {
      "max-age": data.token.expires_in,
      expires: dtExpire,
      path: "/",
      domain: UA_DOMAIN_NAME,
    }
  );
};

export const createCommunityCookie = (data) => {
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() * 1000);
  // const expiry = Date.now() + data.token.expires_in;

  setCookieMaxAge(COMMUNITY_COOKIE_NAME, JSON.stringify(data), {
    // "max-age": data.token.expires_in,
    expires: dtExpire,
    path: "/",
    domain: UA_DOMAIN_NAME,
  });
};

export const setLanguageCookie = (language) => {
  if (!language) {
    return;
  }

  // Persist the selected language in the shared ttp_lang cookie so the choice
  // survives reloads and is read back on app init (Admin/login), instead of
  // living only in localStorage. Mirrors the auth/community cookie writes so the
  // rest of the TTP ecosystem sees the same language.
  const maxAge = 60 * 60 * 24 * 365;
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() + maxAge * 1000);

  setCookieMaxAge(`ttp_lang_${APP_ENV}`, language, {
    "max-age": maxAge,
    expires: dtExpire,
    path: "/",
    domain: UA_DOMAIN_NAME,
  });
};

export function updateAuthCookieGoPeopleOrganizationId(
  jwtToken,
  communityUuid,
  organizationUuid,
  organizationApiId,
  autologin = false,
  userId = null
) {
  const cookieValue = getCookie(`ttp_auth_${APP_ENV}`);
  if (!cookieValue) return;

  let auth = {};
  try {
    auth = JSON.parse(cookieValue);
  } catch (e) {
    console.error("Invalid cookie JSON:", e);
    return;
  }
  if (jwtToken && autologin) {
    auth.jwtToken = jwtToken;
    auth.isAutologin = true;
  } else {
    auth.goPeopleOrganizationId = communityUuid;
    auth.organizationGoApiId = communityUuid;
    auth.communityUuid = organizationUuid;
    auth.communityApiId = organizationApiId;
  }
  if (userId) {
    auth.userId = userId;
  }
  
  const ttlSeconds = Number(auth.expiresIn) > 0 ? Number(auth.expiresIn) : 3600;
  const dtExpire = new Date(Date.now() + ttlSeconds * 1000);

  setAuthCookie(JSON.stringify(auth), dtExpire);
}
export const updateAuthCookie = (updatedAuth) => {
  if (!updatedAuth) return;

  const currentAuth = getAuthInfosFromCookie();
  if (!currentAuth) return;

  const newAuth = {
    ...currentAuth,
    ...updatedAuth,
  };

  const dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() + (newAuth.expiresIn || 3600) * 1000);

  setAuthCookie(JSON.stringify(newAuth), dtExpire);
};

// Builds the `navCommunity` object consumed across the app (and persisted in
// the community cookie).
// - DISPLAY fields (name/abbreviation/logo) come straight from the community —
//   the nav shows the community name + logo, never an organization value.
// - FUNCTIONAL fields (id = TTP organization id, uuid = GoPeople organization
//   id, selectedOrganization) come from the selected organization; they drive
//   the fiduciary fetch, redirection and access checks.
export function buildNavCommunityFromOrg(org, communityUuid, community) {
  if (!org && !community) return null;
  return {
    id: org?.ttp_organization_id ?? community?.ttp_community_id ?? null,
    uuid: org?.uuid ?? community?.uuid ?? null,
    uen: org?.uen || "",
    name: community?.community_name || "",
    abbreviation: community?.community_name || "",
    avatarUrl: community?.logo_url,
    logo_url: community?.logo_url,
    communityUuid: communityUuid ?? community?.uuid ?? org?.community_id,
    selectedOrganization: org ?? null,
    office_size: org?.office_size,
  };
}

// A community rendered as an organization entry — used as a display fallback
// for the switcher when a community has no linked organizations loaded.
function communityAsOrgEntry(community) {
  return {
    id: community.ttp_community_id,
    uuid: community.uuid,
    uen: "",
    name: community.community_name || "",
    abbreviation: community.community_name || "",
    avatarUrl: community.logo_url,
    communityUuid: community.uuid,
    selectedOrganization: null,
  };
}

// Extracts the selected community's organizations from the
// GET /users/me/selected-community response, injecting community_id so
// downstream consumers can rely on it.
export function extractSelectedCommunityOrgs(selectedCommunityInfo, communityUuid) {
  const orgs = selectedCommunityInfo?.organizations;
  if (!Array.isArray(orgs)) return [];
  return orgs.map((org) => ({
    ...org,
    community_id: org.community_id ?? communityUuid,
  }));
}

// Maps a raw GoPeople organization to the entry shape used inside `uaRoles`.
function buildOrganizationEntry(org, communityUuid) {
  return {
    id: org.ttp_organization_id,
    uuid: org.uuid,
    uen: org.uen || "",
    name: org.official_name || "",
    abbreviation: org.short_name || "",
    avatarUrl: org.logo_url,
    communityUuid: communityUuid ?? org.community_id,
    selectedOrganization: org,
  };
}

// Builds `uaRoles` from the complete-profile payload and a map of
// community uuid -> linked organizations. No TTP-id matching: the backend
// already scopes organizations to their community.
export function buildUaRolesFromProfile(userData, linkedOrgsByCommunity) {
  return (userData.communities || []).flatMap((community) => {
    const roleForCommunity = (userData.roles || []).find(
      (r) => r.community_id === community.uuid
    );

    const organizations = (linkedOrgsByCommunity?.[community.uuid] || []).map(
      (org) => buildOrganizationEntry(org, community.uuid)
    );

    return [
      {
        id: community.ttp_community_id,
        community_id: community.uuid,
        function: community.community_name || "",
        // Community-level display fields for the switcher row.
        name: community.community_name || "",
        avatarUrl: community.logo_url,
        type: roleForCommunity?.role || "",
        typeStatus: roleForCommunity?.type_status || "",
        validated: !!community.ua_status,
        internal: false,
        exist: false,
        createdAt: community.createdAt || new Date().toISOString(),
        organizations,
        // The switcher row represents the community; the organizations array
        // above powers the sub-items when a community has several.
        organization: organizations[0] || communityAsOrgEntry(community),
      },
    ];
  });
}

export function transformGoApiUser(
  userData,
  selectedCommunity,
  linkedOrgsByCommunity,
  userBlogRole
) {
  if (!userData) {
    return null;
  }
  const user = userData.user;

  const selectedCommunityOrgs =
    linkedOrgsByCommunity?.[selectedCommunity?.uuid] || [];
  // On boot there is no explicit selected organization on the payload, so we
  // default to the first organization of the selected community.
  const selectedOrganization = selectedCommunityOrgs[0] || null;

  const enrichedBlogRole = [].concat(userBlogRole || []).map((role) => ({
    ...role,
    organizationId: selectedOrganization?.ttp_organization_id || null,

    blogRoleInOrganization: (role.blogRoleInOrganization || []).map(
      (orgRole) => ({
        ...orgRole,
        organizationId: selectedOrganization?.ttp_organization_id || null,
      })
    ),
  }));

  const navCommunity = buildNavCommunityFromOrg(
    selectedOrganization,
    selectedCommunity?.uuid,
    selectedCommunity
  );

  const selectedRoleForCommunity = (userData.roles || []).find(
    (r) => r.community_id === selectedCommunity?.uuid
  );

  const uaRoles = buildUaRolesFromProfile(userData, linkedOrgsByCommunity);

  const transformedUser = {
    id: user.ttp_user_id || null,
    firstName: user.firstname || "",
    lastName: user.lastname || "",
    mainEmail: user.email || "",
    mainPhone: user.phone || "",
    avatarUrl: user.avatar_url || "",
    email: [{ email: user.email }, ...(user.secondary_emails || [])],
    phone: [{ phone: user.phone }, ...(user.secondary_phones || [])],
    language: user.main_language || "fr",
    gender: user.sex || "",
    function: "",
    type: "",
    enabled: true,
    acceptCookies: true,
    hasPassword: true,

    selectedCommunity: {
      ...selectedCommunity,
      id: selectedCommunity?.ttp_community_id,
    },
    pending_invitation: {
      token: userData.pending_invitation,
    },
    blogRole: enrichedBlogRole,
    uaRoles,
    currentCommunity: selectedCommunity,
    communities: userData.communities || [],

    role: {
      id: selectedCommunity?.ttp_community_id,
      function: "",
      mandate: "",
      type: selectedRoleForCommunity?.role,
      typeStatus: selectedRoleForCommunity?.type_status,
    },

    title: user.sex === "MALE" ? "Monsieur" : "Madame",
    salutation: user.sex === "MALE" ? "Cher Confrère" : "Chère Consœur",

    url: `${user.firstname}-${user.lastname}`
      .toLowerCase()
      .replace(/\s+/g, "-"),

    activityCount: 0,
    roles: [],
    description: "",
    isSecure: false,
    institute: "",
    numeroAgreation: "",
    userMobilePhone: { intlFormat: user.phone, countryCode: "be" },
    userSettings: { id: null, talkSettings: [] },
    type: user.type,
    isUaAdmin: user.is_ua_admin,
  };

  return {
    folder: [],
    role: {
      id: selectedCommunity?.ttp_community_id,
      type: selectedRoleForCommunity?.role,
      typeStatus: selectedRoleForCommunity?.type_status,
    },
    user: transformedUser,
    organization: selectedCommunity,
    navCommunity: navCommunity,
  };
}

export function transformFidToOrganization(
  fid,
  organisationSettings,
  uaSettings,
  uaHasAccess = null
) {
  if (!fid) return null;

  return {
    ...(organisationSettings || {}),
    id: fid.ttp_organization_id ?? null,
    uen: fid.uen ?? "",
    name: fid.official_name ?? "",
    abbreviation: fid.short_name ?? "",
    address1: fid.address_1,
    address2: fid.address_2,
    city: fid.city,
    zipCode: fid.zip_code,
    country: fid.country,
    website: fid.website ?? "",
    legalForm: fid.legal_form ?? "",
    languagePreferences: fid.language ?? "",
    mandate: fid.mandate ?? "",
    type: fid.type ?? "",
    sector: {
      id: fid.sector_id ?? null,
    },
    latitude: null,
    longitude: null,
    avatarUrl: fid.logo_url,
    avatarWebPath: fid.cover_url ?? "",
    agreation: (() => {
      try {
        return fid.agreation_number ? JSON.parse(fid.agreation_number) : null;
      } catch (_) {
        return null;
      }
    })(),
    mastery: fid.mastery ?? null,
    legalRepresentative: fid.legalRepresentative ?? null,
    startDate: fid.start_date ?? null,
    uaStatus: fid.ua_status,
    onBoardingStep: fid.on_boarding_step,
    uaMode: fid.ua_mode,
    // Saved to gopeople by the settings page (which forwards them to TTP), so
    // they are read back from gopeople too. Absent when the organization has none.
    studentDomainEmails: fid.student_domain_emails ?? [],
    uaSettings: uaSettings,
    hasMastery: fid.mastery_id ? true : false,
    isClient: true,
    isActive: true,
    uaHasAccess,
    uaPlan: fid.ua_plan ?? "LITE",
  };
}
